import directive from './v-inline-font';

export default {
  install(Vue) {
    Vue.directive('inline-font', directive)
  },
  directive,
}
